import { render, staticRenderFns } from "./AppStaffListGroupBlock.vue?vue&type=template&id=349542ee&scoped=true"
import script from "./AppStaffListGroupBlock.vue?vue&type=script&lang=js"
export * from "./AppStaffListGroupBlock.vue?vue&type=script&lang=js"
import style0 from "./AppStaffListGroupBlock.vue?vue&type=style&index=0&id=349542ee&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "349542ee",
  null
  
)

export default component.exports